import { FlightDropdownOption } from 'components/Flights/types'
import StructureLabel from 'LuxKit/Label/StructureLabel'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'

interface Props extends Utils.PropsWithDataAttributes {
  selected: boolean
  option: FlightDropdownOption
  onOptionSelect: (option: FlightDropdownOption) => void
}

function FareDropdownOption(props: Props) {
  const { option, onOptionSelect, ...rest } = props
  const intl = useIntl()

  const onSelect = useCallback(() => {
    onOptionSelect(option)
  }, [option, onOptionSelect])

  const comingSoonText = intl.formatMessage({
    id: 'n1X1QRxI2G',
    defaultMessage: 'Coming soon!',
    description: 'Label indicating that a fare option is coming soon',
  })

  return (
    <ClickableListItem
      {...rest}
      title={option.label}
      key={option.value}
      onClick={onSelect}
      disabled={option.disabled}
    >
      {option.comingSoon && <StructureLabel variant="information">
        {comingSoonText}
      </StructureLabel>}
    </ClickableListItem>
  )
}

export default FareDropdownOption
